// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + ({"933":"backend","966":"login"}[chunkId] || chunkId) + "." + {"341":"fe2aef55","342":"3651d9a7","500":"1be75042","512":"37efb5fb","933":"c4f735a9","966":"1be75042"}[chunkId] + ".css";
};